
interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('accueil')}>
            <img
              src="https://static.readdy.ai/image/04f309692b2e018ede3a87223bcd45f5/9c004d6f62865f7af24a6b7c5c519d60.png"
              alt="BR CLEAN AUTO"
              className="h-16 w-auto object-contain"
            />
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('accueil')}
              className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#0EA5E9] ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              Accueil
            </button>
            <button
              onClick={() => scrollToSection('prestations')}
              className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#0EA5E9] ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              Prestations
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#0EA5E9] ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              Contact
            </button>
            <button
              onClick={() => scrollToSection('reviews')}
              className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#0EA5E9] ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              Vos Avis
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className={`text-sm font-medium transition-colors whitespace-nowrap hover:text-[#0EA5E9] ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              Galerie
            </button>
            <a
              href="tel:0695104394"
              className="bg-[#0EA5E9] text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-[#0284C7] transition-colors whitespace-nowrap"
            >
              06 95 10 43 94
            </a>
          </div>

          <button
            className="md:hidden"
            onClick={() => {
              const menu = document.getElementById('mobile-menu');
              menu?.classList.toggle('hidden');
            }}
          >
            <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-800' : 'text-white'}`}></i>
          </button>
        </div>

        <div id="mobile-menu" className="hidden md:hidden mt-4 pb-4">
          <div className="flex flex-col space-y-3">
            <button
              onClick={() => scrollToSection('accueil')}
              className="text-sm font-medium text-gray-800 hover:text-[#0EA5E9] transition-colors text-left whitespace-nowrap"
            >
              Accueil
            </button>
            <button
              onClick={() => scrollToSection('prestations')}
              className="text-sm font-medium text-gray-800 hover:text-[#0EA5E9] transition-colors text-left whitespace-nowrap"
            >
              Prestations
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-sm font-medium text-gray-800 hover:text-[#0EA5E9] transition-colors text-left whitespace-nowrap"
            >
              Contact
            </button>
            <button
              onClick={() => scrollToSection('reviews')}
              className="text-sm font-medium text-gray-800 hover:text-[#0EA5E9] transition-colors text-left whitespace-nowrap"
            >
              Vos Avis
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className="text-sm font-medium text-gray-800 hover:text-[#0EA5E9] transition-colors text-left whitespace-nowrap"
            >
              Galerie
            </button>
            <a
              href="tel:0695104394"
              className="bg-[#0EA5E9] text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-[#0284C7] transition-colors text-center whitespace-nowrap"
            >
              06 95 10 43 94
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}